export var DeferredPromiseStatus;
(function (DeferredPromiseStatus) {
    DeferredPromiseStatus["Pending"] = "pending";
    DeferredPromiseStatus["Resolved"] = "resolved";
    DeferredPromiseStatus["Rejected"] = "rejected";
})(DeferredPromiseStatus || (DeferredPromiseStatus = {}));
/**
 * Documentation for Deferred Promises:
 * https://dev.azure.com/Office/Office/_wiki/wikis/Microsoft-Search/88574/Deferred-Promises
 **/
var DeferredPromise = /** @class */ (function () {
    function DeferredPromise() {
        var _this = this;
        this.state = DeferredPromiseStatus.Pending;
        this.resolve = function (_) { return undefined; };
        this.reject = function (_) { return undefined; };
        this.data = new Promise(function (resolve, reject) {
            _this.resolve = function (data) {
                if (_this.state === DeferredPromiseStatus.Pending) {
                    _this.state = DeferredPromiseStatus.Resolved;
                    resolve(data);
                }
            };
            _this.reject = function (error) {
                if (_this.state === DeferredPromiseStatus.Pending) {
                    _this.state = DeferredPromiseStatus.Rejected;
                    reject(error);
                }
            };
        });
    }
    return DeferredPromise;
}());
export { DeferredPromise };
//# sourceMappingURL=DeferredPromise.js.map